// Glider Configuration
new Glider(document.querySelector(".carousel-institucional-glider-2"), {
    slidesToShow: 1,
    slidesToScroll: 1,
    scrollLock: true,
    draggable: true,
    duration: 2,
    arrows: {
      prev: "#carrossel-anterior",
      next: "#carrossel-proximo"
    },
    dots: ".carousel-institucional-dots-template4",
  })
  
  function translateAriaCarouselHeader() {
    document.querySelector('.carousel-institucional #carrossel-anterior')
      .setAttribute('aria-label', 'Anterior')
    document.querySelector('.carousel-institucional #carrossel-proximo')
      .setAttribute('aria-label', 'Próxima')
  
    document.querySelectorAll('.carousel-institucional-dots-template4 button.glider-dot').forEach(button => {
      button.setAttribute('aria-label', `Página ${button.getAttribute('data-index')}`)
    })
  }
  
  translateAriaCarouselHeader()